export const prices = [
  {
    _id: 0,
    name: 'Any',
    array: [],
  },
  {
    _id: 1,
    name: '₹100 to ₹300',
    array: [100, 300],
  },
  {
    _id: 2,
    name: '₹301 to ₹500',
    array: [301, 500],
  },
  {
    _id: 3,
    name: '₹501 to ₹1000',
    array: [501, 1000],
  },
  {
    _id: 4,
    name: '₹1001 to ₹1500',
    array: [1001, 1500],
  },
  {
    _id: 5,
    name: 'More Than ₹1501',
    array: [1501, 2999],
  },
];